import { render, staticRenderFns } from "./impowerDetail.vue?vue&type=template&id=21a9dfa2&scoped=true&"
import script from "./impowerDetail.vue?vue&type=script&lang=js&"
export * from "./impowerDetail.vue?vue&type=script&lang=js&"
import style0 from "./impowerDetail.vue?vue&type=style&index=0&id=21a9dfa2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21a9dfa2",
  null
  
)

export default component.exports